// extracted by mini-css-extract-plugin
export var headlineBox = "Headline1-module--headlineBox--8eVnL";
export var headline = "Headline1-module--headline--TYTJL";